function E() {
}
function Ne(t) {
  return t();
}
function he() {
  return /* @__PURE__ */ Object.create(null);
}
function L(t) {
  t.forEach(Ne);
}
function Se(t) {
  return typeof t == "function";
}
function Oe(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let Z;
function le(t, e) {
  return Z || (Z = document.createElement("a")), Z.href = e, t === Z.href;
}
function _e(t) {
  return Object.keys(t).length === 0;
}
function ee(t) {
  return t == null ? "" : t;
}
function k(t, e) {
  t.appendChild(e);
}
function Le(t, e, r) {
  const s = Te(t);
  if (!s.getElementById(e)) {
    const i = I("style");
    i.id = e, i.textContent = r, Fe(s, i);
  }
}
function Te(t) {
  if (!t)
    return document;
  const e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && e.host ? e : t.ownerDocument;
}
function Fe(t, e) {
  k(t.head || t, e);
}
function V(t, e, r) {
  t.insertBefore(e, r || null);
}
function B(t) {
  t.parentNode.removeChild(t);
}
function fe(t, e) {
  for (let r = 0; r < t.length; r += 1)
    t[r] && t[r].d(e);
}
function I(t) {
  return document.createElement(t);
}
function K(t) {
  return document.createTextNode(t);
}
function F() {
  return K(" ");
}
function D(t, e, r, s) {
  return t.addEventListener(e, r, s), () => t.removeEventListener(e, r, s);
}
function m(t, e, r) {
  r == null ? t.removeAttribute(e) : t.getAttribute(e) !== r && t.setAttribute(e, r);
}
function Ee(t) {
  return Array.from(t.childNodes);
}
function Be(t, e) {
  e = "" + e, t.wholeText !== e && (t.data = e);
}
let R;
function Y(t) {
  R = t;
}
function Pe() {
  if (!R)
    throw new Error("Function called outside component initialization");
  return R;
}
function We(t) {
  Pe().$$.on_mount.push(t);
}
const W = [], be = [], J = [], me = [], Qe = Promise.resolve();
let de = !1;
function Ye() {
  de || (de = !0, Qe.then(Ie));
}
function ge(t) {
  J.push(t);
}
const te = /* @__PURE__ */ new Set();
let H = 0;
function Ie() {
  const t = R;
  do {
    for (; H < W.length; ) {
      const e = W[H];
      H++, Y(e), Ue(e.$$);
    }
    for (Y(null), W.length = 0, H = 0; be.length; )
      be.pop()();
    for (let e = 0; e < J.length; e += 1) {
      const r = J[e];
      te.has(r) || (te.add(r), r());
    }
    J.length = 0;
  } while (W.length);
  for (; me.length; )
    me.pop()();
  de = !1, te.clear(), Y(t);
}
function Ue(t) {
  if (t.fragment !== null) {
    t.update(), L(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(ge);
  }
}
const Re = /* @__PURE__ */ new Set();
function Ve(t, e) {
  t && t.i && (Re.delete(t), t.i(e));
}
function Ge(t, e, r, s) {
  const { fragment: i, on_mount: o, on_destroy: a, after_update: d } = t.$$;
  i && i.m(e, r), s || ge(() => {
    const c = o.map(Ne).filter(Se);
    a ? a.push(...c) : L(c), t.$$.on_mount = [];
  }), d.forEach(ge);
}
function Ze(t, e) {
  const r = t.$$;
  r.fragment !== null && (L(r.on_destroy), r.fragment && r.fragment.d(e), r.on_destroy = r.fragment = null, r.ctx = []);
}
function He(t, e) {
  t.$$.dirty[0] === -1 && (W.push(t), Ye(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function Xe(t, e, r, s, i, o, a, d = [-1]) {
  const c = R;
  Y(t);
  const l = t.$$ = {
    fragment: null,
    ctx: null,
    props: o,
    update: E,
    not_equal: i,
    bound: he(),
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (c ? c.$$.context : [])),
    callbacks: he(),
    dirty: d,
    skip_bound: !1,
    root: e.target || c.$$.root
  };
  a && a(l.root);
  let h = !1;
  if (l.ctx = r ? r(t, e.props || {}, (g, u, ...j) => {
    const v = j.length ? j[0] : u;
    return l.ctx && i(l.ctx[g], l.ctx[g] = v) && (!l.skip_bound && l.bound[g] && l.bound[g](v), h && He(t, g)), u;
  }) : [], l.update(), h = !0, L(l.before_update), l.fragment = s ? s(l.ctx) : !1, e.target) {
    if (e.hydrate) {
      const g = Ee(e.target);
      l.fragment && l.fragment.l(g), g.forEach(B);
    } else
      l.fragment && l.fragment.c();
    e.intro && Ve(t.$$.fragment), Ge(t, e.target, e.anchor, e.customElement), Ie();
  }
  Y(c);
}
class Je {
  $destroy() {
    Ze(this, 1), this.$destroy = E;
  }
  $on(e, r) {
    const s = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return s.push(r), () => {
      const i = s.indexOf(r);
      i !== -1 && s.splice(i, 1);
    };
  }
  $set(e) {
    this.$$set && !_e(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
function qe(t) {
  Le(t, "svelte-1gnjz2", `.sr-only.svelte-1gnjz2.svelte-1gnjz2{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}.fixed.svelte-1gnjz2.svelte-1gnjz2{position:fixed}.inset-0.svelte-1gnjz2.svelte-1gnjz2{top:0px;right:0px;bottom:0px;left:0px}.z-40.svelte-1gnjz2.svelte-1gnjz2{z-index:40}.z-50.svelte-1gnjz2.svelte-1gnjz2{z-index:50}.mx-6.svelte-1gnjz2.svelte-1gnjz2{margin-left:1.5rem;margin-right:1.5rem}.mb-4.svelte-1gnjz2.svelte-1gnjz2{margin-bottom:1rem}.flex.svelte-1gnjz2.svelte-1gnjz2{display:flex}.h-8.svelte-1gnjz2.svelte-1gnjz2{height:2rem}.w-full.svelte-1gnjz2.svelte-1gnjz2{width:100%}.w-8.svelte-1gnjz2.svelte-1gnjz2{width:2rem}.max-w-\\[500px\\].svelte-1gnjz2.svelte-1gnjz2{max-width:500px}@-webkit-keyframes svelte-1gnjz2-spin{to{transform:rotate(360deg)}}@keyframes svelte-1gnjz2-spin{to{transform:rotate(360deg)}}.animate-spin.svelte-1gnjz2.svelte-1gnjz2{-webkit-animation:svelte-1gnjz2-spin 1s linear infinite;animation:svelte-1gnjz2-spin 1s linear infinite}.cursor-pointer.svelte-1gnjz2.svelte-1gnjz2{cursor:pointer}.flex-col.svelte-1gnjz2.svelte-1gnjz2{flex-direction:column}.items-center.svelte-1gnjz2.svelte-1gnjz2{align-items:center}.justify-center.svelte-1gnjz2.svelte-1gnjz2{justify-content:center}.justify-between.svelte-1gnjz2.svelte-1gnjz2{justify-content:space-between}.gap-3.svelte-1gnjz2.svelte-1gnjz2{gap:0.75rem}.rounded-md.svelte-1gnjz2.svelte-1gnjz2{border-radius:0.375rem}.rounded-full.svelte-1gnjz2.svelte-1gnjz2{border-radius:9999px}.bg-black\\/25.svelte-1gnjz2.svelte-1gnjz2{background-color:rgb(0 0 0 / 0.25)}.bg-slate-50.svelte-1gnjz2.svelte-1gnjz2{--tw-bg-opacity:1;background-color:rgb(248 250 252 / var(--tw-bg-opacity))}.bg-slate-100.svelte-1gnjz2.svelte-1gnjz2{--tw-bg-opacity:1;background-color:rgb(241 245 249 / var(--tw-bg-opacity))}.fill-neutral-600.svelte-1gnjz2.svelte-1gnjz2{fill:#525252}.p-4.svelte-1gnjz2.svelte-1gnjz2{padding:1rem}.p-3.svelte-1gnjz2.svelte-1gnjz2{padding:0.75rem}.text-center.svelte-1gnjz2.svelte-1gnjz2{text-align:center}.text-xl.svelte-1gnjz2.svelte-1gnjz2{font-size:1.25rem;line-height:1.75rem}.text-neutral-300.svelte-1gnjz2.svelte-1gnjz2{--tw-text-opacity:1;color:rgb(212 212 212 / var(--tw-text-opacity))}.antialiased.svelte-1gnjz2.svelte-1gnjz2{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.shadow.svelte-1gnjz2.svelte-1gnjz2{--tw-shadow:0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}.shadow-sm.svelte-1gnjz2.svelte-1gnjz2{--tw-shadow:0 1px 2px 0 rgb(0 0 0 / 0.05);--tw-shadow-colored:0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}.filter.svelte-1gnjz2.svelte-1gnjz2{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-sm.svelte-1gnjz2.svelte-1gnjz2{--tw-backdrop-blur:blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition-colors.svelte-1gnjz2.svelte-1gnjz2{transition-property:color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}.svelte-1gnjz2.svelte-1gnjz2,.svelte-1gnjz2.svelte-1gnjz2::before,.svelte-1gnjz2.svelte-1gnjz2::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}.svelte-1gnjz2.svelte-1gnjz2::before,.svelte-1gnjz2.svelte-1gnjz2::after{--tw-content:''}h1.svelte-1gnjz2.svelte-1gnjz2{font-size:inherit;font-weight:inherit}a.svelte-1gnjz2.svelte-1gnjz2{color:inherit;text-decoration:inherit}.svelte-1gnjz2.svelte-1gnjz2:-moz-focusring{outline:auto}.svelte-1gnjz2.svelte-1gnjz2:-moz-ui-invalid{box-shadow:none}.svelte-1gnjz2.svelte-1gnjz2::-webkit-inner-spin-button,.svelte-1gnjz2.svelte-1gnjz2::-webkit-outer-spin-button{height:auto}.svelte-1gnjz2.svelte-1gnjz2::-webkit-search-decoration{-webkit-appearance:none}.svelte-1gnjz2.svelte-1gnjz2::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}h1.svelte-1gnjz2.svelte-1gnjz2{margin:0}ul.svelte-1gnjz2.svelte-1gnjz2{list-style:none;margin:0;padding:0}[role="button"].svelte-1gnjz2.svelte-1gnjz2{cursor:pointer}.svelte-1gnjz2.svelte-1gnjz2:disabled{cursor:default}img.svelte-1gnjz2.svelte-1gnjz2,svg.svelte-1gnjz2.svelte-1gnjz2{display:block;vertical-align:middle}img.svelte-1gnjz2.svelte-1gnjz2{max-width:100%;height:auto}.svelte-1gnjz2.svelte-1gnjz2,.svelte-1gnjz2.svelte-1gnjz2::before,.svelte-1gnjz2.svelte-1gnjz2::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }.svelte-1gnjz2.svelte-1gnjz2::-webkit-backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }.svelte-1gnjz2.svelte-1gnjz2::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }.svelte-1gnjz2.svelte-1gnjz2{font-family:Nunito, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
      Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue,
      sans-serif;-webkit-font-smoothing:antialiased}.hover\\:bg-slate-200.svelte-1gnjz2.svelte-1gnjz2:hover{--tw-bg-opacity:1;background-color:rgb(226 232 240 / var(--tw-bg-opacity))}.dark.svelte-1gnjz2 .dark\\:border-neutral-600.svelte-1gnjz2{--tw-border-opacity:1;border-color:rgb(82 82 82 / var(--tw-border-opacity))}.dark.svelte-1gnjz2 .dark\\:bg-neutral-900.svelte-1gnjz2{--tw-bg-opacity:1;background-color:rgb(23 23 23 / var(--tw-bg-opacity))}.dark.svelte-1gnjz2 .dark\\:bg-neutral-800.svelte-1gnjz2{--tw-bg-opacity:1;background-color:rgb(38 38 38 / var(--tw-bg-opacity))}.dark.svelte-1gnjz2 .dark\\:fill-neutral-300.svelte-1gnjz2{fill:#d4d4d4}.dark.svelte-1gnjz2 .dark\\:text-white.svelte-1gnjz2{--tw-text-opacity:1;color:rgb(255 255 255 / var(--tw-text-opacity))}.dark.svelte-1gnjz2 .dark\\:text-neutral-600.svelte-1gnjz2{--tw-text-opacity:1;color:rgb(82 82 82 / var(--tw-text-opacity))}.dark.svelte-1gnjz2 .dark\\:hover\\:bg-neutral-700.svelte-1gnjz2:hover{--tw-bg-opacity:1;background-color:rgb(64 64 64 / var(--tw-bg-opacity))}`);
}
function pe(t, e, r) {
  const s = t.slice();
  return s[20] = e[r], s;
}
function Me(t, e, r) {
  const s = t.slice();
  return s[23] = e[r], s;
}
function Ke(t) {
  let e, r;
  return {
    c() {
      e = I("img"), m(e, "alt", t[23].name), le(e.src, r = t[23].icon) || m(e, "src", r), m(e, "class", "w-8 h-8 rounded-full svelte-1gnjz2");
    },
    m(s, i) {
      V(s, e, i);
    },
    p: E,
    d(s) {
      s && B(e);
    }
  };
}
function $e(t) {
  let e;
  return {
    c() {
      e = I("div"), e.innerHTML = `<svg aria-hidden="true" class="w-8 h-8 text-neutral-300 animate-spin dark:text-neutral-600 fill-neutral-600 dark:fill-neutral-300 svelte-1gnjz2" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" class="svelte-1gnjz2"></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" class="svelte-1gnjz2"></path></svg> 
              <span class="sr-only svelte-1gnjz2">Loading...</span>`, m(e, "role", "status"), m(e, "class", "svelte-1gnjz2");
    },
    m(r, s) {
      V(r, e, s);
    },
    p: E,
    d(r) {
      r && B(e);
    }
  };
}
function ve(t) {
  let e, r = t[23].name + "", s, i, o, a;
  function d(u, j) {
    return u[1] === u[23].id ? $e : Ke;
  }
  let c = d(t), l = c(t);
  function h() {
    return t[12](t[23]);
  }
  function g(...u) {
    return t[13](t[23], ...u);
  }
  return {
    c() {
      e = I("li"), s = K(r), i = F(), l.c(), m(e, "class", "flex justify-between items-center p-3 bg-slate-100 rounded-md cursor-pointer shadow-sm hover:bg-slate-200 transition-colors dark:bg-neutral-800 dark:hover:bg-neutral-700 dark:border-neutral-600 dark:text-white svelte-1gnjz2");
    },
    m(u, j) {
      V(u, e, j), k(e, s), k(e, i), l.m(e, null), o || (a = [
        D(e, "click", h),
        D(e, "keyup", g)
      ], o = !0);
    },
    p(u, j) {
      t = u, c === (c = d(t)) && l ? l.p(t, j) : (l.d(1), l = c(t), l && (l.c(), l.m(e, null)));
    },
    d(u) {
      u && B(e), l.d(), o = !1, L(a);
    }
  };
}
function je(t) {
  let e, r, s, i = t[20].name + "", o, a, d, c, l, h, g, u, j, v;
  return {
    c() {
      e = I("a"), r = I("li"), s = K("Install "), o = K(i), a = F(), d = I("img"), h = F(), m(d, "alt", c = t[20].name), le(d.src, l = t[20].icon) || m(d, "src", l), m(d, "class", "w-8 h-8 rounded-full svelte-1gnjz2"), m(r, "class", "flex justify-between items-center p-3 bg-slate-100 rounded-md shadow-sm cursor-pointer hover:bg-slate-200 transition-colors dark:bg-neutral-800 dark:hover:bg-neutral-700 dark:border-neutral-600 dark:text-white svelte-1gnjz2"), m(e, "alt", g = t[20].name + " download link"), m(e, "href", u = t[20].download), m(e, "target", "_blank"), m(e, "rel", "noopener noreferrer"), m(e, "class", "svelte-1gnjz2");
    },
    m(y, M) {
      V(y, e, M), k(e, r), k(r, s), k(r, o), k(r, a), k(r, d), k(e, h), j || (v = [
        D(r, "click", t[14]),
        D(r, "keyup", t[15])
      ], j = !0);
    },
    p(y, M) {
      M & 1 && i !== (i = y[20].name + "") && Be(o, i), M & 1 && c !== (c = y[20].name) && m(d, "alt", c), M & 1 && !le(d.src, l = y[20].icon) && m(d, "src", l), M & 1 && g !== (g = y[20].name + " download link") && m(e, "alt", g), M & 1 && u !== (u = y[20].download) && m(e, "href", u);
    },
    d(y) {
      y && B(e), j = !1, L(v);
    }
  };
}
function et(t) {
  let e, r, s, i, o, a, d, c, l, h, g, u, j = t[4], v = [];
  for (let f = 0; f < j.length; f += 1)
    v[f] = ve(Me(t, j, f));
  let y = t[0], M = [];
  for (let f = 0; f < y.length; f += 1)
    M[f] = je(pe(t, y, f));
  return {
    c() {
      e = I("div"), r = I("main"), s = I("header"), i = I("h1"), i.textContent = "Connect a wallet", o = F(), a = I("span"), a.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 0 24 24" fill="currentColor" class="svelte-1gnjz2"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" class="svelte-1gnjz2"></path></svg>', d = F(), c = I("ul");
      for (let f = 0; f < v.length; f += 1)
        v[f].c();
      l = F();
      for (let f = 0; f < M.length; f += 1)
        M[f].c();
      m(i, "class", "text-xl svelte-1gnjz2"), m(a, "role", "button"), m(a, "alt", "Close"), m(a, "class", "cursor-pointer svelte-1gnjz2"), m(s, "class", "flex items-center justify-between mb-4 svelte-1gnjz2"), m(c, "class", "flex flex-col gap-3 svelte-1gnjz2"), m(r, "role", "dialog"), m(r, "class", ee("bg-slate-50 rounded-md shadow w-full max-w-[500px] mx-6 p-4 text-center z-50 dark:bg-neutral-900 dark:text-white") + " svelte-1gnjz2"), m(e, "class", h = ee("backdrop-blur-sm fixed inset-0 flex items-center justify-center bg-black/25 z-40 " + t[2]) + " svelte-1gnjz2");
    },
    m(f, x) {
      V(f, e, x), k(e, r), k(r, s), k(s, i), k(s, o), k(s, a), k(r, d), k(r, c);
      for (let w = 0; w < v.length; w += 1)
        v[w].m(c, null);
      k(c, l);
      for (let w = 0; w < M.length; w += 1)
        M[w].m(c, null);
      g || (u = [
        D(a, "click", t[10]),
        D(a, "keyup", t[11]),
        D(r, "click", tt),
        D(r, "keyup", rt),
        D(e, "click", t[16]),
        D(e, "keyup", t[17])
      ], g = !0);
    },
    p(f, [x]) {
      if (x & 26) {
        j = f[4];
        let w;
        for (w = 0; w < j.length; w += 1) {
          const O = Me(f, j, w);
          v[w] ? v[w].p(O, x) : (v[w] = ve(O), v[w].c(), v[w].m(c, l));
        }
        for (; w < v.length; w += 1)
          v[w].d(1);
        v.length = j.length;
      }
      if (x & 9) {
        y = f[0];
        let w;
        for (w = 0; w < y.length; w += 1) {
          const O = pe(f, y, w);
          M[w] ? M[w].p(O, x) : (M[w] = je(O), M[w].c(), M[w].m(c, null));
        }
        for (; w < M.length; w += 1)
          M[w].d(1);
        M.length = y.length;
      }
      x & 4 && h !== (h = ee("backdrop-blur-sm fixed inset-0 flex items-center justify-center bg-black/25 z-40 " + f[2]) + " svelte-1gnjz2") && m(e, "class", h);
    },
    i: E,
    o: E,
    d(f) {
      f && B(e), fe(v, f), fe(M, f), g = !1, L(u);
    }
  };
}
const tt = (t) => t.stopPropagation(), rt = (t) => t.stopPropagation();
function st(t, e, r) {
  const s = typeof window < "u" ? window : null;
  let { lastWallet: i = null } = e, { installedWallets: o = [] } = e, { preAuthorizedWallets: a = [] } = e, { discoveryWallets: d = [] } = e, { callback: c = async () => {
  } } = e, { theme: l = null } = e, h = !1, g = async (b) => {
    var G;
    r(1, h = (G = b == null ? void 0 : b.id) != null ? G : !1), await c(b).catch(() => {
    }), r(1, h = !1);
  }, u = "";
  l === "dark" || l === null && (s == null ? void 0 : s.matchMedia("(prefers-color-scheme: dark)").matches) ? u = "dark" : u = "";
  const j = (b) => {
    r(2, u = b.matches ? "dark" : "");
  };
  We(() => {
    if (l === null)
      return s == null || s.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", j), () => {
        s == null || s.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", j);
      };
  });
  const v = [i, ...a, ...o].filter(Boolean), y = () => g(null), M = (b) => {
    b.key === "Enter" && g(null);
  }, f = (b) => g(b), x = (b, G) => {
    G.key === "Enter" && g(b);
  }, w = () => g(null), O = (b) => {
    b.key === "Enter" && g(null);
  }, xe = () => g(null), Ce = (b) => {
    b.key === "Escape" && g(null);
  };
  return t.$$set = (b) => {
    "lastWallet" in b && r(5, i = b.lastWallet), "installedWallets" in b && r(6, o = b.installedWallets), "preAuthorizedWallets" in b && r(7, a = b.preAuthorizedWallets), "discoveryWallets" in b && r(0, d = b.discoveryWallets), "callback" in b && r(8, c = b.callback), "theme" in b && r(9, l = b.theme);
  }, [
    d,
    h,
    u,
    g,
    v,
    i,
    o,
    a,
    c,
    l,
    y,
    M,
    f,
    x,
    w,
    O,
    xe,
    Ce
  ];
}
class nt extends Je {
  constructor(e) {
    super(), Xe(
      this,
      e,
      st,
      et,
      Oe,
      {
        lastWallet: 5,
        installedWallets: 6,
        preAuthorizedWallets: 7,
        discoveryWallets: 0,
        callback: 8,
        theme: 9
      },
      qe
    );
  }
}
function re(t, e) {
  return t.filter((r) => !e.some((s) => s.id === r.id));
}
async function it({
  discoveryWallets: t,
  installedWallets: e,
  lastWallet: r,
  preAuthorizedWallets: s,
  enable: i,
  modalOptions: o
}) {
  return new Promise((a) => {
    var l;
    const d = [r].filter(Boolean);
    s = re(s, d), e = re(e, [
      ...d,
      ...s
    ]), t = re(t, [
      ...d,
      ...e,
      ...s
    ]);
    const c = new nt({
      target: document.body,
      props: {
        callback: async (h) => {
          var u;
          const g = (u = await (i == null ? void 0 : i(h))) != null ? u : h;
          c.$destroy(), a(g);
        },
        lastWallet: r,
        installedWallets: e,
        preAuthorizedWallets: s,
        discoveryWallets: t,
        theme: (o == null ? void 0 : o.theme) === "system" ? null : (l = o == null ? void 0 : o.theme) != null ? l : null
      }
    });
  });
}
const ot = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, Ae = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, z = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, N = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, S = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class n {
  static getFirstMatch(e, r) {
    const s = r.match(e);
    return s && s.length > 0 && s[1] || "";
  }
  static getSecondMatch(e, r) {
    const s = r.match(e);
    return s && s.length > 1 && s[2] || "";
  }
  static matchAndReturnConst(e, r, s) {
    if (e.test(r))
      return s;
  }
  static getWindowsVersionName(e) {
    switch (e) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  static getMacOSVersionName(e) {
    const r = e.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    if (r.push(0), r[0] === 10)
      switch (r[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  static getAndroidVersionName(e) {
    const r = e.split(".").splice(0, 2).map((s) => parseInt(s, 10) || 0);
    if (r.push(0), !(r[0] === 1 && r[1] < 5)) {
      if (r[0] === 1 && r[1] < 6)
        return "Cupcake";
      if (r[0] === 1 && r[1] >= 6)
        return "Donut";
      if (r[0] === 2 && r[1] < 2)
        return "Eclair";
      if (r[0] === 2 && r[1] === 2)
        return "Froyo";
      if (r[0] === 2 && r[1] > 2)
        return "Gingerbread";
      if (r[0] === 3)
        return "Honeycomb";
      if (r[0] === 4 && r[1] < 1)
        return "Ice Cream Sandwich";
      if (r[0] === 4 && r[1] < 4)
        return "Jelly Bean";
      if (r[0] === 4 && r[1] >= 4)
        return "KitKat";
      if (r[0] === 5)
        return "Lollipop";
      if (r[0] === 6)
        return "Marshmallow";
      if (r[0] === 7)
        return "Nougat";
      if (r[0] === 8)
        return "Oreo";
      if (r[0] === 9)
        return "Pie";
    }
  }
  static getVersionPrecision(e) {
    return e.split(".").length;
  }
  static compareVersions(e, r, s = !1) {
    const i = n.getVersionPrecision(e), o = n.getVersionPrecision(r);
    let a = Math.max(i, o), d = 0;
    const c = n.map([e, r], (l) => {
      const h = a - n.getVersionPrecision(l), g = l + new Array(h + 1).join(".0");
      return n.map(g.split("."), (u) => new Array(20 - u.length).join("0") + u).reverse();
    });
    for (s && (d = a - Math.min(i, o)), a -= 1; a >= d; ) {
      if (c[0][a] > c[1][a])
        return 1;
      if (c[0][a] === c[1][a]) {
        if (a === d)
          return 0;
        a -= 1;
      } else if (c[0][a] < c[1][a])
        return -1;
    }
  }
  static map(e, r) {
    const s = [];
    let i;
    if (Array.prototype.map)
      return Array.prototype.map.call(e, r);
    for (i = 0; i < e.length; i += 1)
      s.push(r(e[i]));
    return s;
  }
  static find(e, r) {
    let s, i;
    if (Array.prototype.find)
      return Array.prototype.find.call(e, r);
    for (s = 0, i = e.length; s < i; s += 1) {
      const o = e[s];
      if (r(o, s))
        return o;
    }
  }
  static assign(e, ...r) {
    const s = e;
    let i, o;
    if (Object.assign)
      return Object.assign(e, ...r);
    for (i = 0, o = r.length; i < o; i += 1) {
      const a = r[i];
      typeof a == "object" && a !== null && Object.keys(a).forEach((c) => {
        s[c] = a[c];
      });
    }
    return e;
  }
  static getBrowserAlias(e) {
    return ot[e];
  }
  static getBrowserTypeByAlias(e) {
    return Ae[e] || "";
  }
}
const p = /version\/(\d+(\.?_?\d+)+)/i, at = [
  {
    test: [/googlebot/i],
    describe(t) {
      const e = {
        name: "Googlebot"
      }, r = n.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/opera/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/opr\/|opios/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, r = n.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(t) {
      const e = {
        name: "Samsung Internet for Android"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/Whale/i],
    describe(t) {
      const e = {
        name: "NAVER Whale Browser"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(t) {
      const e = {
        name: "MZ Browser"
      }, r = n.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/focus/i],
    describe(t) {
      const e = {
        name: "Focus"
      }, r = n.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/swing/i],
    describe(t) {
      const e = {
        name: "Swing"
      }, r = n.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/coast/i],
    describe(t) {
      const e = {
        name: "Opera Coast"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(t) {
      const e = {
        name: "Opera Touch"
      }, r = n.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/yabrowser/i],
    describe(t) {
      const e = {
        name: "Yandex Browser"
      }, r = n.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(t) {
      const e = {
        name: "UC Browser"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(t) {
      const e = {
        name: "Maxthon"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/epiphany/i],
    describe(t) {
      const e = {
        name: "Epiphany"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/puffin/i],
    describe(t) {
      const e = {
        name: "Puffin"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/sleipnir/i],
    describe(t) {
      const e = {
        name: "Sleipnir"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/k-meleon/i],
    describe(t) {
      const e = {
        name: "K-Meleon"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/micromessenger/i],
    describe(t) {
      const e = {
        name: "WeChat"
      }, r = n.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(t) {
      const e = {
        name: /qqbrowserlite/i.test(t) ? "QQ Browser Lite" : "QQ Browser"
      }, r = n.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/msie|trident/i],
    describe(t) {
      const e = {
        name: "Internet Explorer"
      }, r = n.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/\sedg\//i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, r = n.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, r = n.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/vivaldi/i],
    describe(t) {
      const e = {
        name: "Vivaldi"
      }, r = n.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/seamonkey/i],
    describe(t) {
      const e = {
        name: "SeaMonkey"
      }, r = n.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/sailfish/i],
    describe(t) {
      const e = {
        name: "Sailfish"
      }, r = n.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/silk/i],
    describe(t) {
      const e = {
        name: "Amazon Silk"
      }, r = n.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/phantom/i],
    describe(t) {
      const e = {
        name: "PhantomJS"
      }, r = n.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/slimerjs/i],
    describe(t) {
      const e = {
        name: "SlimerJS"
      }, r = n.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = {
        name: "BlackBerry"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = {
        name: "WebOS Browser"
      }, r = n.getFirstMatch(p, t) || n.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/bada/i],
    describe(t) {
      const e = {
        name: "Bada"
      }, r = n.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/tizen/i],
    describe(t) {
      const e = {
        name: "Tizen"
      }, r = n.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/qupzilla/i],
    describe(t) {
      const e = {
        name: "QupZilla"
      }, r = n.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(t) {
      const e = {
        name: "Firefox"
      }, r = n.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/electron/i],
    describe(t) {
      const e = {
        name: "Electron"
      }, r = n.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(t) {
      const e = {
        name: "Miui"
      }, r = n.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/chromium/i],
    describe(t) {
      const e = {
        name: "Chromium"
      }, r = n.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, t) || n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(t) {
      const e = {
        name: "Chrome"
      }, r = n.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/GSA/i],
    describe(t) {
      const e = {
        name: "Google Search"
      }, r = n.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test(t) {
      const e = !t.test(/like android/i), r = t.test(/android/i);
      return e && r;
    },
    describe(t) {
      const e = {
        name: "Android Browser"
      }, r = n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/playstation 4/i],
    describe(t) {
      const e = {
        name: "PlayStation 4"
      }, r = n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/safari|applewebkit/i],
    describe(t) {
      const e = {
        name: "Safari"
      }, r = n.getFirstMatch(p, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/.*/i],
    describe(t) {
      const e = /^(.*)\/(.*) /, r = /^(.*)\/(.*)[ \t]\((.*)/, i = t.search("\\(") !== -1 ? r : e;
      return {
        name: n.getFirstMatch(i, t),
        version: n.getSecondMatch(i, t)
      };
    }
  }
], ct = [
  {
    test: [/Roku\/DVP/],
    describe(t) {
      const e = n.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, t);
      return {
        name: N.Roku,
        version: e
      };
    }
  },
  {
    test: [/windows phone/i],
    describe(t) {
      const e = n.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, t);
      return {
        name: N.WindowsPhone,
        version: e
      };
    }
  },
  {
    test: [/windows /i],
    describe(t) {
      const e = n.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, t), r = n.getWindowsVersionName(e);
      return {
        name: N.Windows,
        version: e,
        versionName: r
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(t) {
      const e = {
        name: N.iOS
      }, r = n.getSecondMatch(/(Version\/)(\d[\d.]+)/, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/macintosh/i],
    describe(t) {
      const e = n.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, t).replace(/[_\s]/g, "."), r = n.getMacOSVersionName(e), s = {
        name: N.MacOS,
        version: e
      };
      return r && (s.versionName = r), s;
    }
  },
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(t) {
      const e = n.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, t).replace(/[_\s]/g, ".");
      return {
        name: N.iOS,
        version: e
      };
    }
  },
  {
    test(t) {
      const e = !t.test(/like android/i), r = t.test(/android/i);
      return e && r;
    },
    describe(t) {
      const e = n.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, t), r = n.getAndroidVersionName(e), s = {
        name: N.Android,
        version: e
      };
      return r && (s.versionName = r), s;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = n.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, t), r = {
        name: N.WebOS
      };
      return e && e.length && (r.version = e), r;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = n.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, t) || n.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, t) || n.getFirstMatch(/\bbb(\d+)/i, t);
      return {
        name: N.BlackBerry,
        version: e
      };
    }
  },
  {
    test: [/bada/i],
    describe(t) {
      const e = n.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, t);
      return {
        name: N.Bada,
        version: e
      };
    }
  },
  {
    test: [/tizen/i],
    describe(t) {
      const e = n.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: N.Tizen,
        version: e
      };
    }
  },
  {
    test: [/linux/i],
    describe() {
      return {
        name: N.Linux
      };
    }
  },
  {
    test: [/CrOS/],
    describe() {
      return {
        name: N.ChromeOS
      };
    }
  },
  {
    test: [/PlayStation 4/],
    describe(t) {
      const e = n.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: N.PlayStation4,
        version: e
      };
    }
  }
], lt = [
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  {
    test: [/huawei/i],
    describe(t) {
      const e = n.getFirstMatch(/(can-l01)/i, t) && "Nova", r = {
        type: z.mobile,
        vendor: "Huawei"
      };
      return e && (r.model = e), r;
    }
  },
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: z.tablet,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/ipad/i],
    describe() {
      return {
        type: z.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: z.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: z.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  {
    test: [/silk/i],
    describe() {
      return {
        type: z.tablet,
        vendor: "Amazon"
      };
    }
  },
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: z.tablet
      };
    }
  },
  {
    test(t) {
      const e = t.test(/ipod|iphone/i), r = t.test(/like (ipod|iphone)/i);
      return e && !r;
    },
    describe(t) {
      const e = n.getFirstMatch(/(ipod|iphone)/i, t);
      return {
        type: z.mobile,
        vendor: "Apple",
        model: e
      };
    }
  },
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: z.mobile,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: z.mobile
      };
    }
  },
  {
    test(t) {
      return t.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: z.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  {
    test(t) {
      return t.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: z.mobile
      };
    }
  },
  {
    test(t) {
      return t.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: z.mobile,
        vendor: "Microsoft"
      };
    }
  },
  {
    test(t) {
      const e = Number(String(t.getOSVersion()).split(".")[0]);
      return t.getOSName(!0) === "android" && e >= 3;
    },
    describe() {
      return {
        type: z.tablet
      };
    }
  },
  {
    test(t) {
      return t.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: z.mobile
      };
    }
  },
  {
    test(t) {
      return t.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: z.desktop,
        vendor: "Apple"
      };
    }
  },
  {
    test(t) {
      return t.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: z.desktop
      };
    }
  },
  {
    test(t) {
      return t.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: z.desktop
      };
    }
  },
  {
    test(t) {
      return t.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: z.tv
      };
    }
  },
  {
    test(t) {
      return t.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: z.tv
      };
    }
  }
], dt = [
  {
    test(t) {
      return t.getBrowserName(!0) === "microsoft edge";
    },
    describe(t) {
      if (/\sedg\//i.test(t))
        return {
          name: S.Blink
        };
      const r = n.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, t);
      return {
        name: S.EdgeHTML,
        version: r
      };
    }
  },
  {
    test: [/trident/i],
    describe(t) {
      const e = {
        name: S.Trident
      }, r = n.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test(t) {
      return t.test(/presto/i);
    },
    describe(t) {
      const e = {
        name: S.Presto
      }, r = n.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test(t) {
      const e = t.test(/gecko/i), r = t.test(/like gecko/i);
      return e && !r;
    },
    describe(t) {
      const e = {
        name: S.Gecko
      }, r = n.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: S.Blink
      };
    }
  },
  {
    test: [/(apple)?webkit/i],
    describe(t) {
      const e = {
        name: S.WebKit
      }, r = n.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  }
];
class ze {
  constructor(e, r = !1) {
    if (e == null || e === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = e, this.parsedResult = {}, r !== !0 && this.parse();
  }
  getUA() {
    return this._ua;
  }
  test(e) {
    return e.test(this._ua);
  }
  parseBrowser() {
    this.parsedResult.browser = {};
    const e = n.find(at, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((s) => this.test(s));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.browser = e.describe(this.getUA())), this.parsedResult.browser;
  }
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  getBrowserName(e) {
    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  parseOS() {
    this.parsedResult.os = {};
    const e = n.find(ct, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((s) => this.test(s));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.os = e.describe(this.getUA())), this.parsedResult.os;
  }
  getOSName(e) {
    const { name: r } = this.getOS();
    return e ? String(r).toLowerCase() || "" : r || "";
  }
  getOSVersion() {
    return this.getOS().version;
  }
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  getPlatformType(e = !1) {
    const { type: r } = this.getPlatform();
    return e ? String(r).toLowerCase() || "" : r || "";
  }
  parsePlatform() {
    this.parsedResult.platform = {};
    const e = n.find(lt, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((s) => this.test(s));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.platform = e.describe(this.getUA())), this.parsedResult.platform;
  }
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  getEngineName(e) {
    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  parseEngine() {
    this.parsedResult.engine = {};
    const e = n.find(dt, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((s) => this.test(s));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.engine = e.describe(this.getUA())), this.parsedResult.engine;
  }
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  getResult() {
    return n.assign({}, this.parsedResult);
  }
  satisfies(e) {
    const r = {};
    let s = 0;
    const i = {};
    let o = 0;
    if (Object.keys(e).forEach((d) => {
      const c = e[d];
      typeof c == "string" ? (i[d] = c, o += 1) : typeof c == "object" && (r[d] = c, s += 1);
    }), s > 0) {
      const d = Object.keys(r), c = n.find(d, (h) => this.isOS(h));
      if (c) {
        const h = this.satisfies(r[c]);
        if (h !== void 0)
          return h;
      }
      const l = n.find(
        d,
        (h) => this.isPlatform(h)
      );
      if (l) {
        const h = this.satisfies(r[l]);
        if (h !== void 0)
          return h;
      }
    }
    if (o > 0) {
      const d = Object.keys(i), c = n.find(d, (l) => this.isBrowser(l, !0));
      if (c !== void 0)
        return this.compareVersion(i[c]);
    }
  }
  isBrowser(e, r = !1) {
    const s = this.getBrowserName().toLowerCase();
    let i = e.toLowerCase();
    const o = n.getBrowserTypeByAlias(i);
    return r && o && (i = o.toLowerCase()), i === s;
  }
  compareVersion(e) {
    let r = [0], s = e, i = !1;
    const o = this.getBrowserVersion();
    if (typeof o == "string")
      return e[0] === ">" || e[0] === "<" ? (s = e.substr(1), e[1] === "=" ? (i = !0, s = e.substr(2)) : r = [], e[0] === ">" ? r.push(1) : r.push(-1)) : e[0] === "=" ? s = e.substr(1) : e[0] === "~" && (i = !0, s = e.substr(1)), r.indexOf(
        n.compareVersions(o, s, i)
      ) > -1;
  }
  isOS(e) {
    return this.getOSName(!0) === String(e).toLowerCase();
  }
  isPlatform(e) {
    return this.getPlatformType(!0) === String(e).toLowerCase();
  }
  isEngine(e) {
    return this.getEngineName(!0) === String(e).toLowerCase();
  }
  is(e, r = !1) {
    return this.isBrowser(e, r) || this.isOS(e) || this.isPlatform(e);
  }
  some(e = []) {
    return e.some((r) => this.is(r));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class gt {
  static getParser(e, r = !1) {
    if (typeof e != "string")
      throw new Error("UserAgent should be a string");
    return new ze(e, r);
  }
  static parse(e) {
    return new ze(e).getResult();
  }
  static get BROWSER_MAP() {
    return Ae;
  }
  static get ENGINE_MAP() {
    return S;
  }
  static get OS_MAP() {
    return N;
  }
  static get PLATFORMS_MAP() {
    return z;
  }
}
var ut = Object.defineProperty, wt = (t, e, r) => e in t ? ut(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ht = (t, e, r) => (wt(t, typeof e != "symbol" ? e + "" : e, r), r), we = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
}, A = (t, e, r) => (we(t, e, "read from private field"), r ? r.call(t) : e.get(t)), P = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, $ = (t, e, r, s) => (we(t, e, "write to private field"), s ? s.call(t, r) : e.set(t, r), r), X = (t, e, r) => (we(t, e, "access private method"), r);
const ft = [
  {
    id: "argentX",
    name: "Argent X",
    icon: "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjQwIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgNDAgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNC43NTgyIC0zLjk3MzY0ZS0wN0gxNC42MjM4QzE0LjI4NTEgLTMuOTczNjRlLTA3IDE0LjAxMzggMC4yODExNzggMTQuMDA2NCAwLjYzMDY4M0MxMy44MDE3IDEwLjQ1NDkgOC44MjIzNCAxOS43NzkyIDAuMjUxODkzIDI2LjM4MzdDLTAuMDIwMjA0NiAyNi41OTMzIC0wLjA4MjE5NDYgMjYuOTg3MiAwLjExNjczNCAyNy4yNzA5TDYuMDQ2MjMgMzUuNzM0QzYuMjQ3OTYgMzYuMDIyIDYuNjQwOTkgMzYuMDg3IDYuOTE3NjYgMzUuODc1NEMxMi4yNzY1IDMxLjc3MjggMTYuNTg2OSAyNi44MjM2IDE5LjY5MSAyMS4zMzhDMjIuNzk1MSAyNi44MjM2IDI3LjEwNTcgMzEuNzcyOCAzMi40NjQ2IDM1Ljg3NTRDMzIuNzQxIDM2LjA4NyAzMy4xMzQxIDM2LjAyMiAzMy4zMzYxIDM1LjczNEwzOS4yNjU2IDI3LjI3MDlDMzkuNDY0MiAyNi45ODcyIDM5LjQwMjIgMjYuNTkzMyAzOS4xMzA0IDI2LjM4MzdDMzAuNTU5NyAxOS43NzkyIDI1LjU4MDQgMTAuNDU0OSAyNS4zNzU5IDAuNjMwNjgzQzI1LjM2ODUgMC4yODExNzggMjUuMDk2OSAtMy45NzM2NGUtMDcgMjQuNzU4MiAtMy45NzM2NGUtMDdaIiBmaWxsPSIjRkY4NzVCIi8+Cjwvc3ZnPgo=",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/argent-x"
    }
  },
  {
    id: "braavos",
    name: "Braavos",
    icon: "data:image/svg+xml;base64,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",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/braavos-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet",
      edge: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc"
    }
  }
], bt = () => `${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, ye = (t) => {
  for (let e = t.length - 1; e > 0; e--) {
    const r = Math.floor(Math.random() * (e + 1));
    [t[e], t[r]] = [t[r], t[e]];
  }
  return t;
};
function se(...t) {
  return (e) => t.reduce((r, s) => r.then(s), Promise.resolve(e));
}
var _, C, U, ue, De, Q, q;
class mt {
  constructor(e) {
    P(this, ue), P(this, Q), P(this, _, !1), P(this, C, void 0), P(this, U, void 0), ht(this, "value"), $(this, U, e), X(this, Q, q).call(this);
  }
  set(e) {
    return !A(this, _) && !X(this, Q, q).call(this) ? !1 : (this.delete(), this.value = e, e && ($(this, C, `${A(this, U)}-${bt()}`), localStorage.setItem(A(this, C), e)), !0);
  }
  get() {
    return X(this, ue, De).call(this), this.value;
  }
  delete() {
    return !A(this, _) && !X(this, Q, q).call(this) ? !1 : (this.value = null, A(this, C) && localStorage.removeItem(A(this, C)), !0);
  }
}
_ = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap(), U = /* @__PURE__ */ new WeakMap(), ue = /* @__PURE__ */ new WeakSet(), De = function() {
  this.value && this.set(this.value);
}, Q = /* @__PURE__ */ new WeakSet(), q = function() {
  try {
    !A(this, _) && typeof window < "u" && ($(this, C, Object.keys(localStorage).find(
      (t) => t.startsWith(A(this, U))
    )), $(this, _, !0), A(this, C) && this.set(localStorage.getItem(A(this, C))));
  } catch (t) {
    console.warn(t);
  }
  return A(this, _);
};
function ne(t, e) {
  var r, s;
  if ((r = e == null ? void 0 : e.include) != null && r.length) {
    const i = new Set(e.include);
    return t.filter((o) => i.has(o.id));
  }
  if ((s = e == null ? void 0 : e.exclude) != null && s.length) {
    const i = new Set(e.exclude);
    return t.filter((o) => !i.has(o.id));
  }
  return t;
}
const ke = async (t) => {
  const e = await Promise.all(
    t.map((r) => r.isPreauthorized().catch(() => !1))
  );
  return t.filter((r, s) => e[s]);
}, pt = (t) => {
  try {
    return t && [
      "request",
      "isConnected",
      "provider",
      "enable",
      "isPreauthorized",
      "on",
      "off",
      "version",
      "id",
      "name",
      "icon"
    ].every((e) => e in t);
  } catch {
  }
  return !1;
};
function ie(t, e) {
  return Object.values(
    Object.getOwnPropertyNames(t).reduce((r, s) => {
      if (s.startsWith("starknet")) {
        const i = t[s];
        e(i) && !r[i.id] && (r[i.id] = i);
      }
      return r;
    }, {})
  );
}
const oe = (t, e) => {
  if (e && Array.isArray(e)) {
    t.sort((s, i) => e.indexOf(s.id) - e.indexOf(i.id));
    const r = t.length - e.length;
    return [
      ...t.slice(r),
      ...ye(t.slice(0, r))
    ];
  } else
    return ye(t);
}, Mt = typeof window < "u" ? window : {}, vt = {
  windowObject: Mt,
  isWalletObject: pt,
  storageFactoryImplementation: (t) => new mt(t)
};
function jt(t = {}) {
  const { storageFactoryImplementation: e, windowObject: r, isWalletObject: s } = {
    ...vt,
    ...t
  }, i = e("gsw-last");
  return {
    getAvailableWallets: async (o = {}) => {
      const a = ie(
        r,
        s
      );
      return se(
        (d) => ne(d, o),
        (d) => oe(d, o.sort)
      )(a);
    },
    getPreAuthorizedWallets: async (o = {}) => {
      const a = ie(
        r,
        s
      );
      return se(
        (d) => ke(d),
        (d) => ne(d, o),
        (d) => oe(d, o.sort)
      )(a);
    },
    getDiscoveryWallets: async (o = {}) => se(
      (a) => ne(a, o),
      (a) => oe(a, o.sort)
    )(ft),
    getLastConnectedWallet: async () => {
      const o = i.get(), a = ie(r, s).find(
        (c) => c.id === o
      ), [d] = await ke(
        a ? [a] : []
      );
      return d || (i.delete(), null);
    },
    enable: async (o, a) => {
      if (await o.enable(a), !o.isConnected)
        throw new Error("Failed to connect to wallet");
      return i.set(o.id), o;
    },
    disconnect: async ({ clearLastWallet: o } = {}) => {
      o && i.delete();
    }
  };
}
const T = jt(), ae = typeof window < "u" ? window : null;
function zt() {
  var e;
  switch ((e = gt.getParser(ae == null ? void 0 : ae.navigator.userAgent).getBrowserName()) == null ? void 0 : e.toLowerCase()) {
    case "firefox":
      return "firefox";
    case "microsoft edge":
      return "edge";
    case "android browser":
    case "chrome":
    case "chromium":
    case "electron":
    case "opera":
    case "vivaldi":
      return "chrome";
    default:
      return null;
  }
}
const ce = async (t) => t ? T.enable(t, { starknetVersion: "v4" }).catch(() => null) : null, yt = async ({
  modalMode: t = "canAsk",
  storeVersion: e = zt(),
  modalTheme: r,
  ...s
} = {}) => {
  var l, h;
  const i = await T.getPreAuthorizedWallets({
    ...s
  }), o = await T.getLastConnectedWallet();
  if (t === "neverAsk") {
    const g = (l = i.find((u) => u.id === (o == null ? void 0 : o.id))) != null ? l : i[0];
    return ce(g);
  }
  const a = await T.getAvailableWallets(s);
  if (t === "canAsk" && o) {
    const g = ((h = i.find((u) => u.id === (o == null ? void 0 : o.id))) != null ? h : a.length === 1) ? a[0] : void 0;
    if (g)
      return ce(g);
  }
  const c = (await T.getDiscoveryWallets(s)).filter((g) => Boolean(g.downloads[e])).map(({ downloads: g, ...u }) => ({
    ...u,
    download: g[e]
  }));
  return it({
    lastWallet: o,
    preAuthorizedWallets: i,
    installedWallets: a,
    discoveryWallets: c,
    enable: ce,
    modalOptions: {
      theme: r
    }
  });
};
function kt(t = {}) {
  return T.disconnect(t);
}
export {
  yt as connect,
  kt as disconnect
};
